import { useState } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { Dropdown } from 'antd';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import csSrc from '@/assets/images/flags/cs.png';
import deSrc from '@/assets/images/flags/de.png';
import enSrc from '@/assets/images/flags/en.png';
import esSrc from '@/assets/images/flags/es.png';
import itSrc from '@/assets/images/flags/it.png';
import plSrc from '@/assets/images/flags/pl.png';
import ruSrc from '@/assets/images/flags/ru.png';
import { Submenu } from '@/modules/ui';

import { Language, supportedLanguages } from '../../contants';
import { useLocale } from '../../hooks/useLocale';
import { useSetLocale } from '../../hooks/useSetLocale';
import * as felaRules from './LanguageSwitcher.rules';

const imgMap: Record<Language, string> = {
    [Language.EN]: enSrc,
    [Language.CS]: csSrc,
    [Language.DE]: deSrc,
    [Language.ES]: esSrc,
    [Language.PL]: plSrc,
    [Language.IT]: itSrc,
    [Language.RU]: ruSrc,
};

export const LanguageSwitcher = () => {
    const [open, setOpen] = useState(false);
    const { css } = useFela();
    const { locale } = useLocale();

    const setLocale = useSetLocale();

    return (
        <Dropdown
            open={open}
            onOpenChange={setOpen}
            trigger={['click']}
            placement='top'
            transitionName=''
            popupRender={() => (
                <Submenu
                    options={supportedLanguages.map(lang => ({
                        key: lang,
                        label: <FormattedMessage id={`language.${lang}`} />,
                    }))}
                    activeKey={locale}
                    onSelect={lang => {
                        setLocale(lang);
                        setOpen(false);
                    }}
                />
            )}
        >
            <button type='button' className={css(felaRules.row)}>
                <img src={imgMap[locale]} alt='' className={css(felaRules.flag)} />
                <span className={css(felaRules.label)}>
                    <FormattedMessage id='sidebar.language' />
                </span>
                <span className={css(felaRules.currentLanguage)}>
                    <FormattedMessage id={`language.${locale}`} />
                </span>
                <IconChevronDown size={16} className={css(felaRules.chevron)} />
            </button>
        </Dropdown>
    );
};
